<template>
    <div>
        <!-- LOADER INICIAR VISTA loadingSpiner.estado -->
        <v-dialog v-model="loadingSpiner.estado" :width="loadingSpiner.ancho">
            <v-card :color="loadingSpiner.colorDialog" dark>
                <v-card-text class="pt-2 text-center">
                {{ loadingSpiner.titulo }}
                <v-progress-linear
                    indeterminate
                    :color="loadingSpiner.color"
                    class="mb-0"
                >
                </v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  export default {
    name: "loading",
    data: () => ({      
    }),
    computed:{
        ...mapState(["loadingSpiner"]),
    },
  };
  </script>

  